export const UI_SIZE = {
  DRAWER_WIDTH: 270,
  APP_NAVBAR_HEIGHT: 65,
} as const;
